import * as React from "react";

function SvgIcRideReport(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.656 3.637A.493.493 0 0112 3.5c.134 0 .253.05.344.137.354.336 1.03.863 1.965.863h.191v1h-5v-1h.19c.937 0 1.612-.527 1.966-.863zM9.691 3c.357 0 .674-.206.933-.451C10.982 2.209 11.467 2 12 2c.533 0 1.018.209 1.376.549.26.245.576.451.933.451H15a1 1 0 011 1h1a2 2 0 012 2v10a1 1 0 11-2 0V6h-1a1 1 0 01-1 1H9a1 1 0 01-1-1H7v12h4.586l-.293-.293a1 1 0 011.414-1.414l2 2a1 1 0 010 1.414l-2 2a1 1 0 01-1.414-1.414l.293-.293H7a2 2 0 01-2-2V6a2 2 0 012-2h1a1 1 0 011-1h.69z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgIcRideReport;
